export default "__VITE_ASSET__CUjGeBVz__"